import ChatWidnow from '../components/chat_room/ChatWindow';

const ChatRoom = () => {
   return <ChatWidnow></ChatWidnow>;
};

export default ChatRoom;
